// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a99085de","389":"e4d90909","455":"f1bfa047","977":"a66f18c8"}[chunkId] + ".chunk.js";
};